<div class="calendar-header">
  <div class="row calendar-month">
    <button (click)="goToLastMonth()" [disabled]="checkCalendarMonthSwitchValidity('last')" class="calendar-arrow"
            mat-icon-button>
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <div class="calendar-current-date">{{currentDate}} {{currentMonth }}</div>
    <button (click)="goToNextMonth()" [disabled]="checkCalendarMonthSwitchValidity('next')" class="calendar-arrow"
            mat-icon-button>
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>
</div>
<button *ngIf="!scheduleDates && !doctorCalendar" (click)="selectAllDaysInMonth()" style="margin-bottom: 20px;">{{ 'select-deselect-month' | translate}}</button>
<div class="calendar-body">
  <div class="row calendar-weekday">
    <div class="cal-cel weekday">{{'mo' | translate}}</div>
    <div class="cal-cel weekday">{{'tue' | translate}}</div>
    <div class="cal-cel weekday">{{'wed' | translate}}</div>
    <div class="cal-cel weekday">{{'thu' | translate}}</div>
    <div class="cal-cel weekday">{{'fr' | translate}}</div>
    <div class="cal-cel weekday">{{'sat' | translate}}</div>
    <div class="cal-cel weekday">{{'su' | translate}}</div>
  </div>
  <div #calendar class="row calendar-date">
    <div *ngFor="let lastDay of daysInLastMonth" class="cal-cel last-month">{{lastDay}}
    </div>
    <div (click)="selectDate(day)" *ngFor="let day of daysInThisMonth"
         [ngClass]="{
             'selected-date': selectedDay(day) || day.lighted,
             'is-first-select': checkFirstSelectedDate(day) || day.first,
             'is-last-select': checkLastSelectedDate(day) || day.last,
             'is-middle-select': checkMiddleSelectedDate(day) || day.lighted,
             'invalid-date' : !day.valid
             }"
         class="cal-cel">
      <span [ngClass]="{currentDate: currentDate === day.date,
          otherDate: currentDate !== day.date,
          'restricted-date': !day.valid}">{{day.date}}</span>
    </div>
    <!--        <div class="cal-cel next-month" *ngFor="let nextDay of daysInNextMonth">{{nextDay}}</div>-->
  </div>
</div>
